export const MuiChip = {
  styleOverrides: {
    label: {
      padding: 0,
    },
  },
  variants: [
    {
      props: { variant: 'status' },
      style: {
        minWidth: '27px',
        height: '15px',
        overflow: 'hidden',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '3px',
        fontSize: '11px',
        fontWeight: '500',
        padding: '2px',
      },
    },
    {
      props: { variant: 'status', color: 'warning' },
      style: {
        color: '#004744',
      },
    },
    {
      props: { variant: 'status', disabled: true },
      style: {
        backgroundColor: '#5C5C5C',
        color: '#004744',
      },
    },
  ],
}
